import * as React from 'react';

import { Box, Button, Loader, Typography } from 'components';
import { OtpInput, Timer } from './components';

import { TEXT } from 'texts';
import { observer } from 'mobx-react-lite';
import { paths } from 'routing';
import { useHistory } from 'react-router-dom';
import { useStores } from 'hooks';
import { useStyles } from './Lookup.styles';
import { useTranslation } from 'react-i18next';

const Lookup = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const styles = useStyles();
  const { errorStore, formStore } = useStores();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const confirm = async () => {
    try {
      setIsLoading(true);
      const { orderStatus } = await formStore.confirm();
      setIsLoading(false);
      if (orderStatus === 'CONFIRMED' || orderStatus === 'PROCESSED') {
        history.push(paths.success);
      } else {
        history.push(paths.error);
      }
    } catch (error) {
      errorStore.setError({ title: TEXT.error, description: (error as Error).message });
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    formStore.validate(['otp']);
    if (formStore.isLookupValid) {
      confirm();
    }
  };

  const handleClick = () => {
    history.goBack();
  };

  return (
    <>
      {isLoading && <Loader />}
      <form className={styles.root} onSubmit={handleSubmit}>
        <Box mt={4}>
          <Typography align="center" textType="title" fontWeight={600}>
            {t(TEXT.confirmTitle)}
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography textColor="grey" textType="text" align="center">
            {t(TEXT.confirmDescription)}
          </Typography>
        </Box>
        <Box mt={2}>
          <OtpInput disabled={isLoading} />
        </Box>
        <Timer />
        <Box mt={'auto'}>
          <Button
            buttonType="round"
            background="gradient"
            fullWidth
            type="submit"
            disabled={isLoading || !formStore.isLookupValid}
          >
            <Typography textColor="white">{t(TEXT.confirm)}</Typography>
          </Button>
        </Box>
        <Box mt={2}>
          <Button fullWidth onClick={handleClick} disabled={isLoading}>
            <Typography>{t(TEXT.cancel)}</Typography>
          </Button>
        </Box>
      </form>
    </>
  );
};

export default observer(Lookup);
